import { createThunkRequest, POST } from '@webapp/account/src/libs/request';

import type { Token } from './api';
import { mapToken } from './api';

export const getTokens = createThunkRequest(
    'api/getTokens',
    async () => {
        const { rows } = await POST('list/token');
        return rows.map(mapToken).sort((a: Token, b: Token) => (b.created.isAfter(a.created) ? 1 : -1));
    },
    { notify: false },
);

export const createToken = createThunkRequest(
    'api/createToken',
    async ({ name }: { name: string }, { dispatch }) => {
        const resp = await POST('create/token', { name });
        await dispatch(getTokens({}));
        return resp;
    },
    { notify: false },
);

export const removeToken = createThunkRequest(
    'api/deleteToken',
    async ({ id }: { id: number }, { dispatch }) => {
        const resp = await POST('delete/token', { id });
        await dispatch(getTokens({}));
        return resp;
    },
    { notify: false },
);
